import { PageEntitiesEdit } from './Edit';
import { PageEntities } from './Overview';

export const ENTITIES = {
  Entities: PageEntities,
  EntitiesEdit: PageEntitiesEdit,
} as const;
